export default __webpack_public_path__ + "static/media/studio.a6b10ad6.jpg";